import { ElementType } from 'react';
import { Element, ElementProps } from '../element';

export const Row = <T extends ElementType = 'div'>(props: ElementProps<T>) => {
  return <Element display="flex" flexDirection="row" {...props} />;
};
